import { ExpertBankAccount } from "./ExpertBankAccount.model"
import { ExpertCourt } from "./ExpertCourt.model"

export class ExpertRegion {
  constructor(json) {
    this.id = json?.id ?? ""

    this.title = json?.title ?? ""
    this.alias = json?.alias ?? ""
    this.code = json?.code ?? ""

    this.orgTitle = json?.orgTitle ?? ""
    this.orgPhone = json?.orgPhone ?? ""
    this.orgAddress = json?.orgAddress ?? ""

    this.bankAccount = new ExpertBankAccount(json?.bankAccount ?? null)

    this.courtCards = json?.courtCards?.map(courtCard => new ExpertCourt(courtCard ?? null)) ?? []
  }
}